import { InsuranceOfferResponseType } from "../../models";

export function findResponseByInsuranceId(
  offerResponses: InsuranceOfferResponseType[],
  insuranceId: string
) {
  const found = offerResponses.find(
    (offerResponse) => offerResponse.insurance.id === insuranceId
  );
  return found ? found.id : undefined;
}
